import StyledButtonIcon from './__styled__/StyledButtonIcon';

interface ButtonIconProps {
  $primary?: boolean;
  $maxHeight?: string;
  $jumbo?: boolean;
  $stretch?: boolean;
  $isColumn?: boolean;
  displayIcon?: React.ReactNode;
}

export default function ButtonIcon({
  $primary = false,
  $maxHeight = undefined,
  $jumbo = false,
  $stretch = false,
  $isColumn = false,
  displayIcon = null,
}: ButtonIconProps) {
  if (!displayIcon) {
    return null;
  }
  // Allow for a placeholder of nothingness.
  if (displayIcon === true) {
    return null;
  }
  if (typeof displayIcon !== 'string') {
    return null;
  }
  return (
    <StyledButtonIcon
      $primary={$primary}
      $maxHeight={$maxHeight}
      $jumbo={$jumbo}
      $stretch={$stretch}
      $isColumn={$isColumn}
    >
      <img src={displayIcon} alt="Icon" />
    </StyledButtonIcon>
  );
}
